import { Box, CircularProgress, Typography } from '@mui/material';

import { appStyles } from '@/theme';

import { SECTION_TITLE_VARIANT, styles } from '../../styles';

interface SummaryTileProps {
  title: string;
  mainStat: string;
  description: string;
  Cta?: () => React.ReactNode;
  isLoading?: boolean;
}

export const SummaryTile = ({
  title,
  mainStat,
  description,
  Cta,
  isLoading,
}: SummaryTileProps) => {
  return (
    <Box
      sx={[
        styles.tile,
        {
          height: 180,
          display: 'flex',
          flexDirection: 'column',
          gap: 1,
        },
      ]}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', gap: 2 }}>
        <Typography
          variant="hero3"
          sx={[appStyles.gradientText, { lineHeight: 1 }]}>
          {isLoading ? <CircularProgress /> : mainStat}
        </Typography>
        {Cta && <Cta />}
      </Box>

      <Typography variant={SECTION_TITLE_VARIANT}>{title}</Typography>

      <Typography variant="caption1" sx={{ color: 'text.main' }}>
        {description}
      </Typography>
    </Box>
  );
};
